import React from "react";
import imgSMI from "../../../assets/Foto/smi.jpg";
import "react-multi-carousel/lib/styles.css";

const SMIPage: React.FC = () => {
    return (
        <div className="flex flex-col">
            <img src={imgSMI} className="w-full h-1/2 md:h-1/2 mt-10" alt="ic-company" />
        </div>
    );
};

export default SMIPage;